<script setup lang="ts">
    import { computed, toRef } from 'vue'

    import type { EvalModelBuilderViewModel } from '@Evaluation/EvaluationModels/Components/EvalModelBuilder'

    // ---------------- props / emits ----------------

    const props = defineProps<{
        viewModel: EvalModelBuilderViewModel
    }>()

    const emit = defineEmits<{
        (e: 'create-evalmodel', goalName: string | null): void
    }>()

    // ---------------- shortcuts ----------------

    const vm = toRef(props, 'viewModel')

    // ---------------- derived ----------------

    const opened = computed(() => vm.value?.opened ?? false)

    const operationInProgress = computed(() => vm.value.operationInProgress)

    const goalError = computed<string | null>(() =>
        vm.value.errors.length ? vm.value.errors[0].Error : null
    )

    // writable computed (mirrors getter/setter)
    const goalName = computed<string | null>({
        get: () => vm.value.goalName,
        set: val => { vm.value.goalName = val }
    })

    // ---------------- actions ----------------

    function handleFormSubmit()
    {
        vm.value.operationInProgress = true
        vm.value.clearValidationErrors()

        emit('create-evalmodel', goalName.value)
    }

    function close()
    {
        vm.value.close()
    }
</script>


<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Create goal</h5>
                        <button type="button" class="close" @click="close">&times;</button>
                    </div>

                    <div class="modal-body">
                        <form id="evalmodel-builder-form" @submit.prevent="handleFormSubmit">
                            <div class="form-group">
                                <label>Goal name:</label>
                                <input v-model.trim="goalName" type="text" class="form-control" required maxlength="100" minlength="2">
                                <small class="text-danger">{{goalError}}</small>
                            </div>
                        </form>
                    </div>

                    <div class="modal-footer">

                        <button type="button" @click="close" class="btn btn-outline-secondary">Cancel</button>
                        <button type="submit" form="evalmodel-builder-form" :disabled="operationInProgress" class="btn btn-primary">
                            <span v-if="operationInProgress"><i class="fa fa-spinner fa-spin"></i> Please wait...</span>
                            <span v-if="!operationInProgress">Create</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>